<template>
    <div>
        <!--  BEGIN NAVBAR  -->
        <Header></Header>
        <!--  END NAVBAR  -->

        <!--  BEGIN MAIN CONTAINER  -->
        <div
            class="main-container"
            id="container"
            :class="[!$store.state.is_show_sidebar ? 'sidebar-closed sbar-open' : '', $store.state.menu_style === 'collapsible-vertical' ? 'collapsible-vertical-mobile' : '']"
        >
            <!--  BEGIN OVERLAY  -->
            <div class="overlay" :class="{ show: !$store.state.is_show_sidebar }" @click="$store.commit('toggleSideBar', !$store.state.is_show_sidebar)"></div>
            <div class="search-overlay" :class="{ show: $store.state.is_show_search }" @click="$store.commit('toggleSearch', !$store.state.is_show_search)"></div>
            <!-- END OVERLAY -->

            <!--  BEGIN SIDEBAR  -->
            <SuperAdminSidebar v-if="userType == 'super_admin'" />

            <AdminSidebar v-else-if="userType == 'admin'" />

            <EmployeeSideBar v-else-if="userType == 'employee'" />

            <LeadSideBar v-else-if="userType == 'lead'" />

            <!--  END SIDEBAR  -->

            <!--  BEGIN CONTENT AREA  -->
            <div id="content" class="main-content">
                <!-- <LoadingScreen /> -->
                <router-view v-slot="{ Component }">
                        <component :is="Component" />
                </router-view>

                <!-- BEGIN FOOTER -->
                <Footer></Footer>
                <!-- END FOOTER -->
            </div>
            <!--  END CONTENT AREA  -->

            <!-- BEGIN APP SETTING LAUNCHER -->
            <app-settings />
            <!-- END APP SETTING LAUNCHER -->
        </div>
    </div>
</template>

<script setup>
    import Header from '@/components/layout/header.vue';
    import SuperAdminSidebar from '@/components/layout/sidebar/super-admin.vue';
    import AdminSidebar from '@/components/layout/sidebar/admin.vue';
    import EmployeeSideBar from '@/components/layout/sidebar/employee.vue';
    import LeadSideBar from '@/components/layout/sidebar/lead.vue';
    import Footer from '@/components/layout/footer.vue';
    import appSettings from '@/components/app-settings.vue';
    import LoadingScreen from '@/components/common/Loader.vue';
    const userType = localStorage.getItem("userType")
</script>
